import { nextTick, App } from 'vue'

const CLICK_THRESHOLD = 5 // 移动距离小于 5px 视为点击

export default function useDragWindowDirective (app: App): void {
  app.directive('drag-window', async (el) => {
    await nextTick()

    const modal = el
    const header = el.getElementsByClassName('drag-title')[0]
    let hasDragged = false
    let left = 0
    let top = 0
    header.style.cursor = 'move'

    header.onpointerdown = (e: { clientX: number; clientY: number; pointerId: number }) => {
      const startX = e.clientX
      const startY = e.clientY
      let moved = false

      // On the first drag, read the element's actual rendered position
      // so we don't lose the CSS-based positioning (e.g. calc()).
      if (!hasDragged) {
        const rect = modal.getBoundingClientRect()
        left = rect.left
        top = rect.top
        hasDragged = true
      }

      header.setPointerCapture(e.pointerId)

      el.onpointermove = (event: { clientX: number; clientY: number }) => {
        const endX = event.clientX
        const endY = event.clientY
        const dx = endX - startX
        const dy = endY - startY

        // 超过阈值才算拖拽
        if (Math.abs(dx) > CLICK_THRESHOLD || Math.abs(dy) > CLICK_THRESHOLD) {
          moved = true
        }

        if (moved) {
          modal.left = left + dx
          modal.top = top + dy
          modal.style.left = modal.left + 'px'
          modal.style.top = modal.top + 'px'
        }
      }
      el.onpointerup = () => {
        if (!moved) {
          // 没有明显移动 → 视为点击，派发自定义事件
          el.dispatchEvent(new CustomEvent('drag-click'))
        } else {
          left = modal.left || 0
          top = modal.top || 0
        }
        el.onpointermove = null
        el.onpointerup = null
        header.releasePointerCapture(e.pointerId)
      }
    }
  })
}
